

import { NgModule, APP_INITIALIZER, ErrorHandler, Injectable, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule  } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

// own libs
import { CoreModule, TransportConfig, AppInitSettingsService, AppUserAuth } from '@ubie/core'; // services, authentication
import { SharedModule } from '@ubie/shared'; // general components
import { ClientCoreLibModule } from '@ubie/client-core'; // client components
import { ClientPagesModule } from '@ubie/client-pages'; // client components combined into ready made pages
import { environment } from '../environments/environment';
import { LoginHelper } from './_helpers/loginHelper';
import { SipHelper } from './_helpers/sipHelper';
import { HttpClientModule } from '@angular/common/http';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SQLite } from '@awesome-cordova-plugins/sqlite/ngx';
import { QRCodeModule } from 'angularx-qrcode';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() { }
  handleError(error) {
    console.error(error?.stack?.toString());
  }
}

// mqtt settings
export function factoryGetConfig(): Promise<TransportConfig> {
  return new Promise((resolve) => { 
    
    console.log("get factory");
    // get currently saved user to use the mqtt username and password
    let currentUser: AppUserAuth = JSON.parse(localStorage.getItem('currentUser'));

    console.log("current user", currentUser)

    var mqtt = environment.mqtt;
    
    mqtt.user = currentUser.mqttUsername;
    mqtt.pass = currentUser.mqttPassword;
    

    console.log('factoryGetConfig', currentUser, mqtt);
    
    return resolve(environment.mqtt);
  });
}

export function loadPageConfiguration(settingsService: AppInitSettingsService) {
  return () => settingsService.getSettingsFromFile(`assets/config/pages-config.json`, environment.configurations.pagesConfig);
}

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [AppComponent],
    imports: [
        HttpClientModule, QRCodeModule,
        BrowserModule, IonicModule.forRoot(), AppRoutingModule,
        SharedModule, ClientCoreLibModule, ClientPagesModule,
        CoreModule.forRoot({
            apiRoot: environment.apiRoot,
            server: environment.server,
            logRoot: environment.logRoot,
            appOrigin: 'client',
            getTransportConfig: factoryGetConfig,
            calendar: environment.calendar,
            cacheUris: [environment.apiRoot + "/jwtgroups", "fonts.googleapis.com", "https://fonts.gstatic.com/s/materialicons", environment.apiRoot + "/jwtcountries", environment.apiRoot + "/jwtTimezones",
                environment.apiRoot + "/jwtTranslations", environment.apiRoot + "/jwtdevices", environment.apiRoot + "/jwtinstallations", environment.apiRoot + "/jwtsecurity", environment.apiRoot + "/jwtusers"],
            semsaWizardUrl: environment.semsaWizardUrl,
            admin: environment.admin,
            publishers: environment.publishers
        }),
        BrowserAnimationsModule
    ],
    providers: [
        AppInitSettingsService,
        LoginHelper,
        SipHelper,
        { provide: APP_INITIALIZER, useFactory: loadPageConfiguration, deps: [AppInitSettingsService], multi: true },
        StatusBar,
        SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
        InAppBrowser,
        SQLite
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
